var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEyeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.9833 10.6963C12.9833 12.3463 11.6499 13.6797 9.99993 13.6797C8.34993 13.6797 7.0166 12.3463 7.0166 10.6963C7.0166 9.04635 8.34993 7.71301 9.99993 7.71301C11.6499 7.71301 12.9833 9.04635 12.9833 10.6963Z",
    stroke: "#808080",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.99987 17.5879C12.9415 17.5879 15.6832 15.8546 17.5915 12.8546C18.3415 11.6796 18.3415 9.7046 17.5915 8.5296C15.6832 5.5296 12.9415 3.79626 9.99987 3.79626C7.0582 3.79626 4.31654 5.5296 2.4082 8.5296C1.6582 9.7046 1.6582 11.6796 2.4082 12.8546C4.31654 15.8546 7.0582 17.5879 9.99987 17.5879Z",
    stroke: "#808080",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeIcon);
export default __webpack_public_path__ + "static/media/eye_icon.8d9ad7d5e54aa5334a20d577a58706fe.svg";
export { ForwardRef as ReactComponent };